let defaultPolicy = {
  ONLY_ONE: (options) => {
    if (options?.length === 1) {
      return options[0]
    }
    return null
  },
  FIRST: (options) => {
    if (options?.length > 0) {
      return options[0]
    }
    return null
  },
  // #6737 满足科室与仓库的关系限制 默认为当前用户的科室
  CURRENT_USER_DEPARTMENT: (options, vue) => {
    const department = vue?.$store?.state?.user?.CurrentTicket?.department
    if (department) {
      return department
    }
    return null
  },
}

export default defaultPolicy
